import { AbsoluteFill } from "remotion";
import { COLORS, FONTS, BADGE_DARK, GLOBS } from "./theme";
import { Background } from "./Background";

export const YouTubeThumbnail: React.FC<{
  title: string;
  number: string;
  tag: string;
  subtitle: string;
}> = ({ title, number, tag, subtitle }) => {
  return (
    <AbsoluteFill
      style={{
        background: `linear-gradient(160deg, ${COLORS.dark} 0%, ${COLORS.darkAlt} 100%)`,
        fontFamily: FONTS.sans,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        padding: "0 80px",
      }}
    >
      <Background theme="dark" />

      <div
        style={{
          position: "absolute",
          top: -120,
          right: -80,
          width: 400,
          height: 400,
          borderRadius: "50%",
          background: GLOBS.goldSmall,
          filter: "blur(80px)",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: -100,
          left: -60,
          width: 300,
          height: 300,
          borderRadius: "50%",
          background: GLOBS.darkGlow,
          filter: "blur(60px)",
        }}
      />

      <div
        style={{
          position: "absolute",
          top: 20,
          right: 20,
          width: 180,
          height: 180,
          borderRadius: "50%",
          border: "1px solid rgba(197,160,89,0.1)",
          opacity: 0.4,
        }}
      />

      <div
        style={{
          position: "absolute",
          top: 30,
          left: 30,
          zIndex: 2,
        }}
      >
        <span style={BADGE_DARK}>{tag}</span>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "baseline",
          gap: 16,
          marginBottom: 16,
          zIndex: 2,
        }}
      >
        <span
          style={{
            fontFamily: FONTS.serif,
            fontSize: 140,
            fontWeight: 700,
            color: COLORS.gold,
            lineHeight: 1,
            opacity: 0.2,
            textShadow: `0 0 60px ${COLORS.gold}20`,
          }}
        >
          {number}
        </span>
        <span
          style={{
            fontFamily: FONTS.serif,
            fontSize: 64,
            fontWeight: 400,
            color: COLORS.white,
            lineHeight: 1.05,
            letterSpacing: "-0.03em",
            textShadow: "0 4px 20px rgba(0,0,0,0.4)",
          }}
        >
          {title}
        </span>
      </div>

      <div
        style={{
          fontSize: 28,
          color: COLORS.textMuted,
          fontWeight: 300,
          marginLeft: 4,
          zIndex: 2,
          textShadow: "0 2px 8px rgba(0,0,0,0.3)",
        }}
      >
        {subtitle}
      </div>

      <div
        style={{
          position: "absolute",
          bottom: 30,
          right: 30,
          fontSize: 12,
          color: COLORS.stoneSubtle,
          letterSpacing: "0.1em",
          textTransform: "uppercase",
          zIndex: 2,
        }}
      >
        Edson Santoro — Analista Corporal
      </div>
    </AbsoluteFill>
  );
};
